// extracted by mini-css-extract-plugin
export var alignCenter = "_79-d";
export var bannerShown = "_79-6";
export var buttonContent = "_79-0";
export var cardList = "_79-1";
export var centerContent = "_79-2";
export var chevron = "_79-3";
export var closePanelButton = "_79-k";
export var conversationContextContainer = "_79-l";
export var conversationDetailContainer = "_79-4";
export var detailWrapper = "_79-7";
export var dropdownButton = "_79-e";
export var dropdownTitle = "_79-9";
export var fullHeight = "_79-5";
export var hidden = "_79-a";
export var icon = "_79-b";
export var mergeSuggestionWrapper = "_79-m";
export var panel = "_79-i";
export var portalButtonsWrapper = "_79-c";
export var right = "_79-j";
export var tableSummaryContainer = "_79-8";
export var tableSummaryHeader = "_79-g";
export var threeDotsButton = "_79-f";
export var wide = "_79-h";